import { Link } from "react-router-dom";
import { useEffect } from "react";
import { useLang } from "@/i18n/LangContext";
import { IMAGES } from "@/lib/images";
import { LOGO_URL } from "@/lib/brand";

export default function About() {
  const { t } = useLang();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section data-testid="about-page" className="bg-[#FAF9F6] min-h-screen">
      {/* Editorial hero band */}
      <div className="relative bg-[#1A3B4D] text-[#FAF9F6] pt-36 pb-24">
        <div className="max-w-5xl mx-auto px-6 lg:px-10">
          <p
            className="text-xs uppercase tracking-overline text-[#0097b2] mb-5"
            data-testid="about-overline"
          >
            {t.about.overline}
          </p>
          <h1
            data-testid="about-title"
            className="font-serif text-4xl md:text-6xl tracking-tight leading-[1.05] max-w-3xl"
          >
            {t.about.title}
          </h1>
          {t.about.kicker && (
            <p className="mt-6 font-serif italic text-2xl text-[#FAF9F6]/85">
              {t.about.kicker}
            </p>
          )}
        </div>
      </div>

      {/* Editorial body */}
      <div className="max-w-5xl mx-auto px-6 lg:px-10 py-20 sm:py-28">
        <div className="grid lg:grid-cols-12 gap-12">
          {/* Left: portrait + meta */}
          <aside className="lg:col-span-4 lg:sticky lg:top-32 self-start space-y-6">
            <div className="aspect-[3/4] overflow-hidden bg-[#F0EDE6]">
              <img
                src="/aida-matteo.jpg"
                alt="Aida e Matteo"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
            <div className="border-t border-[#E0DACE] pt-5 space-y-2">
              <img
                src={LOGO_URL}
                alt="AMAC Family Apartments & Suites"
                className="h-16 w-auto"
              />
              <p className="text-xs uppercase tracking-overline text-[#0097b2]">
                {t.about.cities}
              </p>
            </div>
          </aside>

          {/* Right: letter */}
          <article className="lg:col-span-8 space-y-6">
            <p className="font-serif text-2xl md:text-3xl text-[#121C26] leading-snug">
              {t.about.intro}
            </p>

            {t.about.paragraphs.map((para, i) => (
              <p
                key={i}
                data-testid={`about-paragraph-${i}`}
                className="text-[#4A5D6B] text-base md:text-lg leading-relaxed"
              >
                {para}
              </p>
            ))}

            <div className="pt-8 mt-4 border-t border-[#E0DACE]">
              <p className="font-serif italic text-2xl text-[#1A3B4D]">
                {t.about.signature}
              </p>
            </div>

            <div className="pt-10">
              <Link
                to="/"
                data-testid="about-back-home"
                className="inline-flex items-center px-6 py-3 rounded-full border border-[#1A3B4D] text-[#1A3B4D] text-sm tracking-wide hover:bg-[#1A3B4D] hover:text-[#FAF9F6] transition-colors"
              >
                {t.about.backHome}
              </Link>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
}
